import React from "react";
import { BrowserRouter, NavLink, Route } from "react-router-dom";
import ContentHeader from "../../../Dashboard/Components/ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../Assets/Images/sm-Circle.svg";
import AIServiceMonitoring from "../../../Dashboard/Components/SystemSettings/ServiceMonitoring/AIServiceMonitoring";
import OtherServices from "../../../Dashboard/Components/SystemSettings/ServiceMonitoring/OtherServices";
import { translateText } from "../../../../Helper_functions";

const ServiceMonitoring = (props) => {
  const validateNavigation = (e, Id) => {
    transformIndicator(Id);
  };
  const transformIndicator = (Id) => {
    if (Id === "main") {
      document.getElementById("animated-indicator").style.transform = "none";
    } else {
      window.innerWidth >= 450
        ? (document.getElementById("animated-indicator").style.transform =
            "translateX(226px)")
        : (document.getElementById("animated-indicator").style.transform =
            "translateX(175px)");
    }
  };

  return (
    <BrowserRouter basename="/home/serviceMonitoring">
      <div className="main-content security-settings system-settings app-settings">
        <ContentHeader
          PageName={translateText("application_settings", props.LangData)}
        />
        <div className="content-header">
          <div className="address">
            <p>{translateText("system_settings", props.LangData)}</p>
            <img src={Circle} alt="." />
            <p>{translateText("services_monitoring", props.LangData)}</p>
          </div>
        </div>
        <div className="navogator-holder">
          <div className="actions navigator" id="service-monitoring">
            <span id="animated-indicator"></span>
            <NavLink
              onClick={(e) => validateNavigation(e, "main")}
              activeClassName="active-nav-node"
              exact
              className="service-monitoring"
              id="ai-service-monitoring"
              to="/"
            >
              <p>{translateText("al_service_monitoring", props.LangData)}</p>
            </NavLink>
            <NavLink
              onClick={(e) => validateNavigation(e, "maintain-mode")}
              activeClassName="active-nav-node"
              className="service-monitoring"
              id="other-services"
              to="/OtherServices"
            >
              <p>{translateText("other_services", props.LangData)}</p>
            </NavLink>
          </div>
        </div>
      </div>
      <Route path="/OtherServices" exact>
        <OtherServices LangData={props.LangData} />
      </Route>
      <Route path="/" exact>
        <AIServiceMonitoring LangData={props.LangData} />
      </Route>
    </BrowserRouter>
  );
};

export default ServiceMonitoring;
